<template>
    <div class="header">
        <div class="header-box">
            <div class="header-head">
                <div class="head-left">
                    <el-image :src="require('@/assets/header_1.png')"
                        style="width: 5rem;height: 4.8125rem;margin-right: .625rem; cursor: pointer;"
                        @click="goHome"></el-image>
                    <el-image :src="require('@/assets/header_2.png')" style="width: 18rem;height: 3.875rem;"></el-image>
                </div>
                <div class="head-right">
                    <div class="ipt">
                        <!-- <el-input v-if="$store.state.language == 1" size="mini" placeholder="搜索"
                            prefix-icon="el-icon-search" v-model="$store.state.input" @change="searchResult"></el-input> -->
                        <el-input v-if="$store.state.language == 1" size="mini" placeholder="搜索"
                            v-model="$store.state.input" @change="searchResult">
                            <i slot="prefix" class="el-input__icon el-icon-search" @click="searchResult"></i>
                        </el-input>
                        <el-input v-else size="mini" placeholder="search" v-model="$store.state.input"
                            @change="searchResult">
                            <i slot="prefix" class="el-input__icon el-icon-search" @click="searchResult"></i>
                        </el-input>
                    </div>
                    <div class="customer-service" @click="goService">
                        <el-image :src="require('@/assets/trust.png')"
                            style="width: 1.625rem;height: 1.625rem;margin-right: .3125rem;"></el-image>
                        <span v-if="$store.state.language == 1" class="service">客户服务</span>
                        <span v-if="$store.state.language == 2" class="services">Service</span>
                    </div>
                </div>
            </div>
            <div class="p-he"></div>
        </div>
    </div>
</template>

<script>
import { Message } from 'element-ui';
export default {
    created() {
    },
    data() {
        return {
            // input: ''
        }
    },

    methods: {
        searchResult() {
            console.log("this.input", this.input)
            // var input = this.input
            var input = this.$store.state.input
            if (this.$store.state.input == '') {
                if (this.$store.state.language == 1) {
                    Message({ type: 'warning', message: '请输入内容', duration: 2000 });
                } else {
                    Message({ type: 'warning', message: 'Please enter content', duration: 2000 });
                }
            } else {
                this.$router.push('/searchResult?input=' + input)
            }
        },

        goService() {
            this.$router.push('/service')
        },
        goHome() {
            this.$router.push('/home')
        }
    }
}
</script>

<style scoped lang="less">
// @media (max-width: 47.9375rem) {}
// @media (min-width: 48rem) and (max-width: 61.9375rem) {}
// @media (min-width: 62rem) and (max-width: 74.9375rem) {}
// @media (min-width: 75rem) {}
@media (max-width: 400px) {
    .header {
        font-size: 5px;
    }

    /deep/.el-input__inner {
        font-size: .9375rem;
        width: 15.625rem !important;
        height: 1.875rem;
        line-height: 1.75rem;
        padding-left: 2.5rem;
        margin-right: .625rem;
    }

    // 
}

.header {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
}

.header-box {
    width: 61.875rem;
    height: 5.9375rem;
    //border: .0625rem solid #eee;
}

.header-head {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
}

.head-left {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 12.5rem;
}

.head-right {
    width: 23.75rem;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    margin-right: 1.25rem;

    .ipt {
        margin-right: 3rem;
    }

    /deep/.el-input__inner {
        font-size: .9375rem;
        width: 12.5rem;
        height: 1.875rem;
        line-height: 1.75rem;
        padding-left: 2.5rem;
        margin-right: .625rem;
    }

    /deep/.el-input__icon {
        cursor: pointer;
        font-size: 1rem;
        line-height: 2rem;
        width: 1.5625rem;
    }
}

.customer-service {
    display: flex;
    width: 8.75rem;
    cursor: pointer;
    justify-content: center;
    align-items: center;

    .service {
        font-size: .875rem;
        color: #767676;
        white-space: nowrap;
    }

    .services {
        font-size: 1rem;
        color: #767676;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/public/Header.vue